

export const CmmFileTypes = [
    { id: 'csv', label: 'CSV' },
    { id: 'excel', label: 'Excel' },
] as const;
export type CmmFileType = (typeof CmmFileTypes)[number]['id'];


export interface ValidationCell {
    row: number;
    column: number;
    value: string;
}

export interface CellLocation {
    row: number;
    column: number;
}

export interface CmmConfigBase<ObjectIdType = string> {
    _id?: ObjectIdType;
    name: string;
    order: number;
    fileType: CmmFileType;
    metadataRows: number;
    validationCells: ValidationCell[];
    equipmentNameCell?: CellLocation;
    positionNumberColumn: number; //0 based index
    positionValueColumn: number; //0 based index
    isActive: boolean;
    createdAt?: Date;
    modifiedAt?: Date;
}
